import Vue from 'vue'
import Router from 'vue-router'
import store from './vuex'
import isNull from 'lodash/isNull'

import auth from '@/modules/auth/routes'
import home from '@/modules/admin/home/routes'
import user from '@/modules/admin/user/routes'
import track from '@/modules/admin/track/routes'
import newReleases from '@/modules/admin/new-releases/routes'
import newsletter from '@/modules/admin/newsletter/routes'
import subscriptionCatalogues from '@/modules/admin/subscription-catalogues/routes'
import reports from '@/modules/admin/reports/routes'
import trackImport from '@/modules/admin/track-import/routes'
import vidcents from '@/modules/admin/vidcents/routes'
import cms from '@/modules/admin/cms/routes'
import challenges from '@/modules/admin/challenges/routes'

import contentIDArtist from '@/modules/artist/content-id/routes'
import artistDashboard from '@/modules/artist/dashboard/routes'
import myTracks from '@/modules/artist/tracks/routes'
import myVideos from '@/modules/artist/videos/routes'
import myChannels from '@/modules/artist/channels/routes'
import influencers from '@/modules/artist/influencers/routes'
import artistMyVidCents from '@/modules/artist/my-vidcents/routes'
import artistVidCentsWallet from '@/modules/artist/vidcents-wallet/routes'
import artistMyProfile from '@/modules/artist/my-profile/routes'

import contentIDLabel from '@/modules/label/content-id/routes'
import myArtists from '@/modules/label/artists/routes'
import labelDashboard from '@/modules/label/dashboard/routes'
import labelMyVidCents from '@/modules/label/my-vidcents/routes'
import labelVidCentsWallet from '@/modules/label/vidcents-wallet/routes'
import labelMyTracks from '@/modules/label/tracks/routes'
import labelMyVideos from '@/modules/label/videos/routes'
import labelMyChannels from '@/modules/label/channels/routes'
import labelMyProfile from '@/modules/label/my-profile/routes'
/*import myTracks from '@/modules/artist/tracks/routes'
import influencers from '@/modules/artist/influencers/routes'
import myVidCents from '@/modules/artist/my-vidcents/routes'
import vidCentsWallet from '@/modules/artist/vidcents-wallet/routes'*/

import contentHome from '@/modules/content/home/routes'
import brands from '@/modules/admin/brand/routes'

// fix for NavigationDuplicated console error
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const routes = [
  ...auth,
  ...home,
  ...user,
  ...track,
  ...newReleases,
  ...newsletter,
  ...subscriptionCatalogues,
  ...reports,
  ...trackImport,
  ...vidcents,
  ...cms,
  ...brands,
  ...challenges,
  ...influencers,
  ...contentIDArtist,
  ...artistDashboard,
  ...myTracks,
  ...myVideos,
  ...myChannels,
  ...myArtists,
  ...contentIDLabel,
  ...artistMyVidCents,
  ...artistVidCentsWallet,
  ...artistMyProfile,
  ...labelDashboard,
  ...labelMyVidCents,
  ...labelVidCentsWallet,
  ...labelMyTracks,
  ...labelMyVideos,
  ...labelMyChannels,
  ...labelMyProfile,
  ...contentHome,
  {
    path: '*',
    component: () => import('@/modules/common/NotFound')
  }
]

const router = new Router({
  mode: 'history',
  // base: process.env.VUE_APP_BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.path.includes('maintenance') && !store.state.auth.maintenance){
    next({
      name: 'Home'
    })
  }
  else if (!to.path.includes('/auth/') && !localStorage.getItem('token')) {
    if(store.state.auth.maintenance){
      next({
        name: 'Maintenance'
      })
    }
    else{
      next({
        name: 'Login'
      })
    }
  }
  else if (
    !to.path.includes('/auth/') &&
    localStorage.getItem('token') &&
    !store.state.auth.user
  ) {
    store.dispatch('auth/readUser').then(() => {
      if(store.state.auth.maintenance){
        next({
          name: 'Maintenance'
        })
      }
      else if (isNull(store.state.auth.user)) {
        next({
          name: 'Login'
        })
      } else {
        if (store.state.auth.user.user_level === 'artist_admin') {
          store.dispatch('auth/readArtist')
        }
        next()
      }
    })
  } else {
    next()
  }
})

router.afterEach(to => {
  document.title = 'SyncVault Admin'
  if (to.name) document.title = to.name + ' - SyncVault Admin'
})

export default router
